<template>
<div>
  <product-card :data="product" />
  <vs-row :gutter="15" v-if="order && order.orderid">
    <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6" vs-sm="12">
      <vx-card title="订单详情" class="mr-0 md:mr-10 mb-5">
        <div class="mb-2"><b>订单号：</b>{{order.orderid}}</div>
        <div class="mb-2"><b>标题：</b>{{order.title}}</div>
        <div class="mb-2"><b>数量：</b>{{order.number}}</div>
        <div class="mb-2"><b>二维码有效期：</b>{{$s.dict.priceMap.qrExpire[order.qrExpire].name}}</div>
        <div class="mb-2"><b>印刷服务：</b>{{order.printing ? '需要' : '不需要'}}</div>
        <div v-if="order.printing && sticky && sticky.id">
          <div class="mb-2"><b>标签形状：</b>{{sticky.shape}}</div>
          <div class="mb-2"><b>标签材质：</b>{{$s.dict.priceMap.material[order.material].name}}</div>
          <div class="mb-2"><b>标签尺寸：</b>{{sticky.width}}CM * {{sticky.height}}CM</div>
          <div class="mb-2"><b>联系人：</b>{{order.contactName}}</div>
          <div class="mb-2"><b>联系电话：</b>{{order.contactPhone}}</div>
          <div class="mb-2"><b>收货地址：</b>{{order.address}}</div>
        </div>
        <div class="mb-2"><b>价格：</b><span class="text-danger">￥{{(order.amount / 100).toFixed(2)}}元</span></div>
      </vx-card>
    </vs-col>
    <vs-col vs-w="6" vs-sm="12">
      <vx-card class="mb-5 text-center" title="支付二维码">
        <img class="inline-block" :src="'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + payUrl">
        <p>请使用微信或支付宝扫码付款</p>
        <p class="text-danger" v-if="$acl.check('order_admin')">
          系统检测到您拥有订单管理权限，您可以<br /> <vs-button color="success" @click="adminPaySuccess">一键成功支付</vs-button>
        </p>
      </vx-card>
    </vs-col>
  </vs-row>
</div>
</template>
<script>
import ProductCard from './product-card'
export default {
  components: {
    ProductCard,
  },
  data() {
    return {
      batch: {},
      product: {},
      order: {},
      sticky: {},
    }
  },
  computed: {
    payUrl() {
      return window.__CONFIG__.api + '/pay/' + this.order.orderid
    }
  },
  async mounted() {
    const res = await this.$s.order.detail(this.$route.params.orderid)
    this.batch = res.batch
    this.product = res.product
    this.order = res.order
    this.sticky = res.sticky
    this.pollCheckPayed()
  },
  beforeDestroy() {
    this.interval && clearInterval(this.interval)
  },
  methods: {
    async adminPaySuccess() {
      // if (!this.$acl.check('order_admin')) {
      //   throw new Error('permission defined')
      // }
      // const {order} = await this.$s.order.update({
      //   ...this.order,
      //   amount: 0,
      // })
      this.$modal('adminPay', {order: this.order})
    },
    paySuccess() {
      this.$notify({
        title: '支付成功',
      })
      this.$router.push('/batchno/detail/' + this.batch.id)
    },
    async pollCheckPayed() {
      this.interval && clearInterval(this.interval)
      this.interval = setInterval(async () => {
        const {order} = await this.$s.order.detail(this.$route.params.orderid)
        if (order.status >= 20) {
          this.interval && clearInterval(this.interval)
          this.$vs.loading({
            text: '订单已完成，正在跳转...'
          })
          setTimeout(() => {
            this.$vs.loading.close()
            this.$router.push('/order/list')
          }, 1000)
        }
      }, 5000)
    }

  }
}
</script>